"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paginated = _interopRequireDefault(require("./paginated"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class MockInfinteScroll extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      page: 0,
      data: []
    });
    _defineProperty(this, "handleSearch", searchText => {
      const {
        filter,
        dataSource = [],
        pageSize
      } = this.props;
      const result = (0, _paginated.default)({
        dataSource,
        pageSize,
        filter: option => filter(searchText, option),
        page: 1
      });
      return this.setState({
        searchText,
        ...result
      });
    });
    _defineProperty(this, "handleOpenClose", open => {
      if (open) {
        return this.setState({
          searchText: null,
          page: 0,
          data: []
        }, this.handleNext);
      }
      return this.setState({
        searchText: null,
        page: 0,
        data: []
      });
    });
    _defineProperty(this, "handleNext", ev => {
      const {
        page = 0,
        searchText,
        totalPages,
        data = []
      } = this.state;
      const {
        filter,
        dataSource = [],
        pageSize
      } = this.props;
      if (!page || page < totalPages) {
        const result = (0, _paginated.default)({
          dataSource,
          pageSize,
          filter: option => filter(searchText, option),
          page: page + 1
        });
        this.setState({
          ...result,
          data: data.concat(result.data)
        });
      }
    });
    this.handleNext = _lodash.default.debounce(this.handleNext, 500, {
      leading: true
    });
  }
  render() {
    const {
      children
    } = this.props;
    const {
      data = []
    } = this.state;
    return children(data, this.handleSearch, this.handleNext, this.handleOpenClose);
  }
}
exports.default = MockInfinteScroll;